import { memo } from "react";
import TextInputPermitPDF from "../../inputs/TextInputPermitPDF";

interface EmployeeInformationProps {
    permitDetails: {
        s_EmployeeName: string;
        s_EmployeeNumber: string;
        s_MobileNumber: string;
        s_Department: string;
    };
}

const EmployeeInformation = ({
    permitDetails,
}: EmployeeInformationProps) => {
    return (
        <div>
            <div className="bg-green-primary text-center border-b border-black py-0.5">
                <span className="text-[10px] font-bold text-white">
                    Section 1: Employee Information
                </span>
            </div>

            <div className="grid grid-cols-2">
                <TextInputPermitPDF
                    label="Employee Name:"
                    value={permitDetails?.s_EmployeeName || ""}
                    labelStyles="border-r border-b w-[40%]"
                    valueStyles="border-r border-b w-[60%]"
                />
                <TextInputPermitPDF
                    label="Employee Number:"
                    value={permitDetails?.s_EmployeeNumber || ""}
                    labelStyles="border-r border-b w-[30%]"
                    valueStyles="border-b w-[70%]"
                />
            </div>

            <div className="grid grid-cols-2">
                <TextInputPermitPDF
                    label="Mobile Number:"
                    value={permitDetails?.s_MobileNumber || ""}
                    labelStyles="border-r border-b w-[40%]"
                    valueStyles="border-r border-b w-[60%]"
                />
                <TextInputPermitPDF
                    label="Department:"
                    value={permitDetails?.s_Department || ""}
                    labelStyles="border-r border-b w-[30%]"
                    valueStyles="border-b w-[70%]"
                />
            </div>
        </div>
    );
};

export default memo(EmployeeInformation);
